import {FreeDayListe} from "../../api";
import {
    SearchMandantFreedaysQuery,
    useSearchMandantFreedays
} from "../../client/hooks";
import {FreedaysFilter} from "../../components/freedays/table/FilterTableFreedays";
import type { DataRequestParams } from "../../components/data";



export const useFreedaysHandling = (mandantId: string) => {
    const searchMandantFreedays: (mandantId: string, query: SearchMandantFreedaysQuery) => Promise<FreeDayListe> = useSearchMandantFreedays();
    const loadFreedays = async (params: DataRequestParams<FreedaysFilter>, filter: FreedaysFilter): Promise<FreeDayListe> => {
        const search: string | undefined = filter.search?.toLowerCase();
        const filtered: string | undefined = filter.filtered ?? params.filtered ?? undefined;
        const year: number | undefined = filter.year ?? params.year ?? undefined;
        const countryCode: string | undefined = filter.countryCode ?? undefined;
        const page: number = params.page ?? 0;
        const limit: number = params.limit ?? 25;
        const sort: string | undefined = params.sort ?? undefined;

        return await searchMandantFreedays(mandantId,{
            search: search,
            filtered: filtered,
            year: year,
            countryCode: countryCode,
            page: page,
            limit: limit,
            sort: sort,
        })
    }
    return{
        loadFreedays
    }
}